<template>
  <base-dialog
    v-model="dialog"
    max-width="500px"
    min-width="300px"
    title="Đặt lại mật khẩu người dùng"
    width="50%"
    @close="onClose"
  >
    <p v-if="passwordChecked === false" class="subtitle-1 black--text">
      Để tiếp tục vui lòng xác nhận danh tính của bạn.
    </p>
    <base-form ref="form" @submit.stop="action">
      <v-row no-gutters>
        <template v-if="passwordChecked === false">
          <v-col cols="12">
            <field-group autofocus label="Nhập mật khẩu của bạn">
              <template #input>
                <FieldToggleShow
                  v-model="editData.password"
                  autocomplete="password"
                  autofocus
                  :error-messages="errors.password"
                  :rules="[...rules.required, ...rules.password]"
                />
              </template>
            </field-group>
          </v-col>
        </template>
        <template v-else>
          <v-col class="py-0" cols="12">
            <field-group :label="$t('register.password')" required>
              <template #input="{ rules }">
                <FieldPassword
                  v-model="editData.new_password"
                  autocomplete="new-password"
                  :error-messages="errors.password"
                  name="password"
                  placeholder="*********"
                  :rules="rules"
                >
                  <!-- <template #append>
                    <base-button
                      icon
                      tooltip="Tạo mật khẩu ngẫu nhiên"
                      @click="generatePassword"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </base-button>
                    <base-button
                      icon
                      tooltip="Sao chép mật khẩu"
                      @click="copyToClipboard(editData.new_password)"
                    >
                      <v-icon>mdi-content-copy</v-icon>
                    </base-button>
                  </template> -->
                </FieldPassword>
              </template>
            </field-group>
          </v-col>
          <v-col class="py-0" cols="12">
            <field-group
              :label="$t('register.comfirmPassword')"
              name="passwordcomfirm"
              required
              :rules="[passwordConfirmationRule]"
            >
              <template #input="{ rules }">
                <FieldToggleShow
                  v-model="editData.password_confirmation"
                  autocomplete="new-password"
                  :error-messages="errors.password_confirmation"
                  placeholder="*********"
                  :rules="rules"
                />
              </template>
            </field-group>
          </v-col>
        </template>
      </v-row>
    </base-form>
    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :disabled="loading"
        :loading="loading"
        @click="action"
      >
        {{ passwordChecked === false ? 'Gửi' : 'Đổi mật khẩu' }}
      </base-button>
    </template>
  </base-dialog>
</template>
<script>
import FieldPassword from '@components/field/field-password.vue'
import FieldToggleShow from '@components/field/field-toggle-show.vue'
import { sdk } from '@service/http/axios'
import { API_USER } from '@api'
import rules, { passwordRegex } from '@utils/rules'
export default {
  props: {},
  components: { FieldPassword, FieldToggleShow },
  data: () => ({
    id: '',
    loading: false,
    dialog: false,
    editData: {
      new_password: '',
      password_confirmation: '',
    },
    errors: {},
    passwordChecked: false,
    rules,
  }),
  computed: {
    passwordConfirmationRule() {
      const vm = this
      return () =>
        vm.editData.new_password === vm.editData.password_confirmation ||
        vm.$t('validation.notmatchpassword')
    },
  },
  methods: {
    onClose() {
      this.passwordChecked = false
      this.editData = {
        new_password: '',
        password_confirmation: '',
      }
      this.errors = {}
    },
    open(item) {
      if (!item) return
      this.dialog = true
      this.id = item.id
    },
    generatePassword() {
      let password = Math.random()
        .toString(36)
        .slice(-10)
      this.editData.new_password = password
      this.editData.password_confirmation = password
    },
    async checkPassword() {
      if (!(await this.$refs.form.validate())) this.loading = true
      const res = await sdk.request({
        method: 'post',
        url: 'checkPassword',
        data: { password: this.editData.password },
      })
      this.loading = false
      this.passwordChecked = res.data.data
      this.editData.password = undefined
      this.errors.password =
        this.passwordChecked === false ? 'Mật khẩu không đúng' : undefined
    },
    async goChange() {
      if (!(await this.$refs.form.validate())) return
      this.loading = true
      try {
        const res = await API_USER.updatePassword(this.id, {
          password: this.editData.new_password,
          confirm_password: this.editData.password_confirmation,
        })
        if (res.error) {
          const message = this.getErrorMessage(res.error)

          if (typeof message === 'object') {
            this.errors = message
          } else {
            this.$root.$notify({
              type: 'error',
              title: 'Cập nhật thất bại',
              message,
            })
          }
          return
        }
        this.$root.$notify({
          type: 'success',
          message: 'Cập nhật thành công',
        })
        this.onClose()
        this.dialog = false
      } catch (error) {
        const message = this.getErrorMessage(error)

        if (typeof message === 'object') {
          this.errors = message
        } else {
          this.$root.$notify({
            type: 'error',
            title: 'Cập nhật thất bại',
            message,
          })
        }

        throw error
      } finally {
        this.loading = false
      }
    },
    async action() {
      if (!(await this.$refs.form.validate())) return
      if (this.passwordChecked === true) {
        this.goChange()
      } else {
        this.checkPassword()
      }
    },
    getErrorMessage(error) {
      if (error.response) {
        const resData = error.response.data

        if (resData.status_code === 422) {
          return Object.keys(resData.errors).reduce((errors, prop) => {
            errors[prop] = resData.errors[prop].join(', ')

            return errors
          }, {})
        }

        return resData.message
      } else {
        return error.message
      }
    },
    copyToClipboard(value) {
      this.$store.dispatch('copyToClipboard', value)
    },
  },
}
</script>
